import React from "react";
import { Button as AntButton } from "antd";
import { useTranslation } from "react-i18next";

const Button = ({ children, ...props }) => {
    const [t] = useTranslation();
    if (typeof children === "string") children = t(children);

    return <AntButton {...props} children={children} />;
};

export default Button;
